import { HubConnection, HubConnectionBuilder, LogLevel } from "@microsoft/signalr";
import { Subject } from "rxjs";
import { ISignalRHubMessage } from "../interfaces/signalr";
import { log } from "./logger";

let hubConnection: HubConnection;



export const signalRHubSubject: Subject<ISignalRHubMessage> = new Subject<ISignalRHubMessage>();
// export const signalRHubStatus: Subject<ISignalRHubStatus> = new Subject<ISignalRHubStatus>();

export const StartSignalRConnection = async (gamificationURL: string, lanId: string) => {
    if (gamificationURL.endsWith('/') === false) {
        gamificationURL = `${gamificationURL}/`
    }

    hubConnection = new HubConnectionBuilder()
        .withUrl(`${gamificationURL}hubs/games?lanid=${lanId}&admin=true`)
        .configureLogging(LogLevel.Information)
        .withAutomaticReconnect()
        .build();

    registerConnectionHandlers();

    log.debug(`Starting connection with SignalR hub`);
    await hubConnection.start();

    // log.debug(`Registering Handlers`);

    registerCustomHandlers();

    // try {
    //     signalRHubStatus.next({ state: hubConnection.state, showErrorPage: false, errorPageMessage: null });
    // } catch (error) {
    //     log.error(`Subject error`, error)
    // }
}

export const StopSignalRConnection = async () => {
    try {
        if (hubConnection != null) {
            log.debug(`Stopping connection with SignalR hub`);
            await hubConnection.stop();

            // try {
            //     signalRHubStatus.next({ state: hubConnection.state, showErrorPage: false, errorPageMessage: null });
            // } catch (error) {
            //     log.error(`Subject error`, error)
            // }
        }
    } catch (error) {
        log.error(`An error occurred while stopping the connection to the signalR hub`, error)
    }

    log.debug(`Removing Handlers`);
    unregisterCustomHandlers();
}

const registerConnectionHandlers = (): void => {
    hubConnection.onclose((error?: Error) => {
        if (error != null) {
            log.error(`SignalR Hub Connection was closed`, error);
            // try {
            //     signalRHubStatus.next({ state: hubConnection.state, showErrorPage: true, errorPageMessage: errorMessages.SERVER_UNREACHABLE });
            // } catch (error) {
            //     log.error(`Subject error`, error);
            // }
        }
        else {
            log.info(`SignalR Hub Connection was closed`);
        }
    });
    hubConnection.onreconnected((connectionId?: string) => {
        log.info(`SignalR Hub connector successfully re-established the connection (${connectionId})`);
        // try {
        //     signalRHubStatus.next({ state: hubConnection.state, showErrorPage: false, errorPageMessage: null });
        // } catch (error) {
        //     log.error(`Subject error`, error)
        // }
    });
    hubConnection.onreconnecting((error?: Error) => {
        if (error != null) {
            log.info(`SignalR Hub connector is trying to re-establish the connection`);
        }
        else {
            log.error(`SignalR Hub connector is trying to re-establish the connection`, error)
        }

        // try {
        //     signalRHubStatus.next({ state: hubConnection.state, showErrorPage: true, errorPageMessage: errorMessages.SERVER_RECONNECTING });
        // } catch (error) {
        //     log.error(`Subject error`, error)
        // }
    });
}

const registerCustomHandlers = (): void => {
    if (hubConnection != null) {
        hubConnection.on("admin:refresh", (name: string, message) => {
            log.info(`Admin refresh event received: ${name} => ${message}`);
            try {
                signalRHubSubject.next({ name, message } as ISignalRHubMessage);
            } catch (error) {
                log.error(`Subject error`, error)
            }
        });
    }
}

const unregisterCustomHandlers = (): void => {
    if (hubConnection != null) {
        hubConnection.off("gamificationevent:coins");
    }
}